// Non Secret ENV Keys

export const ENV_KEYS = {
  GRAPHQL_API: {
    production: "https://dashboard.brex.com/gpp",
    staging: "https://dashboard.staging.brexapps.com/gpp",
  },
  REDIRECT_URL: {
    production: "https://dashboard.brex.com/signup/activate",
    staging: "https://dashboard.staging.brexapps.com/signup/activate",
  },
  DASHBOARD_LOGIN_URL: {
    production: "https://dashboard.brex.com/login-with-session",
    staging: "https://dashboard.staging.brexapps.com/login-with-session",
  },
  DASHBOARD_ORIGIN_URL: {
    production: "https://dashboard.brex.com",
    staging: "https://dashboard.staging.brexapps.com",
  },
  LOGROCKET_APP_ID: {
    production: "lc9zlj/dashboard-prd",
    staging: "lc9zlj/dashboard-stg",
  },
  HELPSHIFT_PLATFORM_ID: {
    production: "brex_platform_20210721222141104-9d76b54a7f22e78",
    staging: "brex_platform_20210721222141104-9d76b54a7f22e78",
  },
  SANITY_PROJECT_ID: "oijolsw2",
  DASHBOARD_LOCALHOST_TOKEN: "242b7a61-2b88-45b1-8405-7380e6e52966",
  ALGOLIA_APP_ID: "1D918HRDT7",
  ALGOLIA_SEARCH_ONLY_KEY: "85908f5581f831c67d29dd9934cc6191",
  AMPLITUDE_POPULARITY_QUERY: "mk6q8ywr",
  SIERRA_BASE_URL: {
    production:
      "https://sierra.chat/agent/sLKzduwBlbn2uJgBlbn3JFpwo8IVGqKMC8LtqGSwbLM/embed",
    staging:
      "https://sierra.chat/agent/sLKzduwBlbn2uJgBlbn3JFpwo8IVGqKMC8LtqGSwbLM/embed/QA",
  },
};

export default ENV_KEYS;
